<template>
    <div>
        <!-- Choose Section start-->
        <section id="choose" class="price">
            <div class="testimonial-decor">
                <div class="testi-circle2"><img :src='"../assets/images/choose-page.png"' alt=""></div>
            </div>
            <div class="container">
                <h2 class="title text-center">Mengapa Menabung Di <span>eFunding</span></h2>
                <div class="row">
                    <div class="col-lg-3 col-md-6 col-sm-6 col-12 px-lg-1 px-md-2 px-sm-2 py-md-2 py-sm-2 py-2">
                        <div class="features__card">
                            <div class="features__card--img pt-3">
                                <img class="img-fluid" :src='"../assets/images/Sym1.png"' alt="funding-agent">
                            </div>
                            <div class="p-3 features__card--text">
                                <div class="h5">Funding Agent Sharia Platform</div>
                                <p>Efunding sebagai pionir Funding Agent berbasis Syariah di Indonesia</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-6 col-12 px-lg-1 px-md-2 px-sm-2 py-md-2 py-sm-2 py-2">
                        <div class="features__card">
                            <div class="features__card--img pt-3">
                                <img class="img-fluid" :src='"../assets/images/Sym2.png"' alt="funding-mitra">
                            </div>
                            <div class="p-3 features__card--text">
                                <div class="h5">Mitra Efunding yang Kredibe</div>
                                <p>Mitra-mitra Efunding sudah berizin dan diawasi lembaga terpercaya</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-6 col-12 px-lg-1 px-md-2 px-sm-2 py-md-2 py-sm-2 py-2">
                        <div class="features__card">
                            <div class="features__card--img pt-3">
                                <img class="img-fluid" :src='"../assets/images/Sym3.png"' alt="funding-trust">
                            </div>
                            <div class="p-3 features__card--text">
                                <div class="h5">Amanah dan terpercaya</div>
                                <p>Efunding telah berizin usaha serta tercatat di Otoritas Jasa Keuangan</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-6 col-12 px-lg-1 px-md-2 px-sm-2 py-md-2 py-sm-2 py-2">
                        <div class="features__card">
                            <div class="features__card--img pt-3">
                                <img class="img-fluid" :src='"../assets/images/Sym4.png"' alt="funding-syariah">
                            </div>
                            <div class="p-3 features__card--text">
                                <div class="h5">Akses ke berbagai produk syariah</div>
                                <p>Melalui Efunding anda dapat mengakses berbagai produk syariah dari mitra kami</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- Choose Section End -->
    </div>
</template>

<script>

import Content from '../api/content.js';

export default {
    name: 'Choose',
    data() {
        return {
            items: []
        }
    },
    mounted() {
        this.loadData();
    },
    methods: {
        loadData() {
            Content.index()
            .then(res => {
                this.items = res.data
            })
            .catch(err => console.log(err))
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/choose.vue